import { featureFlagsSelectors } from 'app-components/flux/feature-flags';
import { milestonesActions, milestonesSagas } from 'app-components/flux/milestones';
import { preferencesV2Selectors } from 'app-components/flux/preferences-v2';
import NotificationGamificationContent from 'containers/Achievements/components/notificationGamificationContent';
import * as notificationsActions from 'data/notifications/notificationsActions';
import { mkNotification } from 'data/notifications/notificationsTypes';
import { OrderedMap } from 'immutable';
import { put, select, takeEvery } from 'redux-saga/effects';
import { v4 as uuidv4 } from 'uuid';

function* milestoneReceivedWorker(action) {
  const { milestoneData } = action.payload;
  const id = uuidv4();
  const showSnackbar = yield select(featureFlagsSelectors.getFeatureFlag, 'achievements');
  const gsfState = yield select((state) =>
    preferencesV2Selectors.getPreferenceValue(state, 'gsfScreen', 'completed_gsf'),
  );
  const gsfComplete = gsfState === 'completed_gsf';
  if (showSnackbar && gsfComplete) {
    yield put(
      notificationsActions.addNotifications(
        OrderedMap([
          [
            id,
            mkNotification({
              id,
              anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
              snackbarContent: NotificationGamificationContent,
              snackbarContentProps: {
                milestoneData,
                id,
              },
              height: 156,
            }),
          ],
        ]),
      ),
    );
  }
}

export function* milestoneReceivedNotificationWatcher() {
  yield takeEvery(milestonesActions.milestoneReceivedNotification, milestoneReceivedWorker);
}

export default [...milestonesSagas, milestoneReceivedNotificationWatcher];
